module.exports = __webpack_public_path__ + "img/bindCard_icon.691a8cd7.png";